import Vue from 'vue';
import VueI18n from 'vue-i18n';

export const messages: VueI18n.LocaleMessages = {
  en: {
    general: {
      welcome: 'Welcome to the CRM IT Interface for the Belgian Capacity Remuneration Mechanism',
      description: 'In case of questions or problems with the tool, please send an e-mail to {mailto}.',
      error: 'A problem occurred on the website. Please try again later. We apologize for any inconvenience this may cause.',
      captchaerror: 'We identified you as a non-human user and, as such, your actions on this website are limited. If this is an error, please contact Elia (operations.crm@elia.be) to have it fixed.',
      sections: {
        register: 'New to the CRM?',
        accountManagement: 'User account management',
        accountManagementTooltip: 'Users with the Admin role can add, edit or remove user accounts via the Prequalification module.',
        crmModules: 'CRM modules'
      },
      controls: {
        loginintroduction: 'Already have an account ?',
        logindescription: 'Sign in directly',
        loginPQ: 'Prequalification',
        loginAuction: 'Auction',
        loginFS: 'Financial Security',
        loginSM: 'Secondary Market',
        loginPDM: 'Pre-delivery Monitoring',
        loginAvMon: 'Availability and Payback Obligation',
        loginSettlement: 'Remuneration & Settlement',
        login: 'Sign in',
        registerintroduction: 'No account yet ?',
        registerdescription: 'Register as CRM Candidate (company)',
        register: 'Register',
        closeerror: 'Close',
        forgotintroduction: 'Forgot password',
        reactivateaccount: 'Re-activate account',
        forgotdescription: 'Click here',
        privacypolicy: 'Privacy policy'
      }
    },
    register: {
      controls: {
        nextstep: 'Continue',
        backstep: 'Back',
        submit: 'Submit'
      },
      company: {
        step: 'Step 1',
        title: 'Company information',
        description: 'In case you want to submit an application form as a natural person, please contact {mailto}.',
        sections:{
          info: 'Company info',
          address: 'Company address'
        },
        labels: {
          name: 'Company name *',
          street: 'Street *',
          housenumber: 'House number *',
          zip: 'Zip code *',
          city: 'City *',
          country: 'Country *',
          phone: 'Telephone',
          fax: 'Fax',
          registrationnumber: 'Registration number *',
          businessnumber: 'Business number *',
          foundationdate: 'Date of foundation',
          legalstatus: 'Legal status *'
        },
        tooltips: {
          registrationnumber: 'The VAT registration number, sometimes also known as a VAT identification number, is the unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT.\n • In Belgium, the registration number starts with "BE" followed by 10 digits (example: BE0999999999).\n • In Germany, the registration number ("Umsatzsteuer-Identifikationsnummer") starts with "DE" followed by 9 digits (example: DE999999999).',
          businessnumber: 'Businesses use their unique business number as a means of identification.\n • In Belgium, the business number consists of 10 digits, which are the same 10 digits used in the Registration Number.\n • In Germany, the business number ("Betriebssteuernummer") consists of 10 to 13 digits',
        },
        errors: {
          required: {
            name: 'Please enter a company name',
            street: 'Please enter a street',
            number: 'Please enter a house number',
            zip: 'Please enter a zip code',
            city: 'Please enter a city',
            country: 'Please choose a country',
            registrationNumber: 'Please enter a registration number',
            businessnumber: 'Please enter a business number',
            legalstatus: 'Please enter a legal status'
          },
          length: {
            name: 'Company name cannot exceed {maximum} characters',
            street: 'Street cannot exceed {maximum} characters',
            number: 'House number cannot exceed {maximum} characters',
            zip: 'Zip cannot exceed {maximum} characters',
            city: 'City cannot exceed {maximum} characters',
            phone: 'Telephone cannot exceed {maximum} characters',
            fax: 'Fax cannot exceed {maximum} characters',
            registrationNumber: 'registration number cannot exceed {maximum} characters',
            businessnumber: 'Business number cannot exceed {maximum} characters',
          },
          type:{
            alphanumerics: 'Only alphanumeric characters allowed (no points, spaces, or other symbols)',
            countrycode: 'The first two characters should correspond to the ISO 3166 country code (‘BE’ for Belgium)'
          }
        }
      },
      contacts: {
        step: 'Step 2',
        title: 'Contact details',
        contactinteration: 'Contact {number}',
        controls: {
          add: 'add another contact person',
          delete: 'delete',
          deletetitle: 'Delete {contactName}?',
          deletedescription: 'You are about to delete this contact, are you sure you want to proceed?',
          deleteconfirm: 'confirm',
          deletecancel: 'cancel'
        },
        sections:{
          competences: 'I want to be the point of contact:',
          roles: 'Roles'
        },
        labels: {
          language: 'Language *',
          civilstatus: 'Civil status *',
          firstname: 'First name *',
          lastname: 'Last name *',
          function: 'Function *',
          phone: 'Telephone',
          mobile: 'Mobile *',
          email: 'Email *',
          gdprtitle: 'Privacy policy',
          gdpragree: 'Please download the document to consult the privacy policy for the CRM interface.',
          gdprlink: 'Privacy policy'
        },
        errors: {
          required: {
            civilstatus: 'Please choose a civil status',
            language: 'Please choose a language',
            firstName: 'Please enter a first name',
            lastName: 'Please enter a last name',
            function: 'Please enter a function',
            mobile: 'Please enter a mobile number',
            email: 'Please enter an email',
            contactFor: 'Please notice that for your application form to be approved, you need to select the matters indicated with a star (*) for at least one of the provided contact person',
            allcompetences: 'You need to select the matters indicated with a star (*) for at least one of the provided contact person.',
            singleinvestment: 'Only for 1 contact person can be provided for the \'investment file\' related matters',
            gdpr: 'Please check the box to submit your application form'
          },
          length: {
            firstName: 'First name cannot exceed {maximum} characters',
            lastName: 'Last name cannot exceed {maximum} characters',
            function: 'Function cannot exceed {maximum} characters',
            phone: 'Telephone number cannot exceed {maximum} characters',
            mobile: 'Mobile number cannot exceed {maximum} characters',
            email: 'Email cannot exceed {maximum} characters',
          },
          type: {
            email: 'Please enter a valid email address',
          }
        }
      }
    },
    thanks: {
      title: 'Thank you!',
      message: 'Your application form has been received.',
      message2:'Once it has been approved by ELIA, you will receive your accesses to the CRM IT Interface via the e-mail addresses provided for each contact details.',
      back:'Go back to site'
    }
  },
  fr: {
    general: {
      welcome: 'Bienvenue sur l\'Interface IT CRM du Mécanisme de Rémunération de la Capacité belge',
      description: 'En cas de questions ou de problèmes avec l\'outil, veuillez envoyer un e-mail à {mailto}.',
      error: 'Un problème est survenu sur le site web. Veuillez réessayer plus tard. Veuillez nous excuser pour les désagréments occasionnés.',
      captchaerror: 'Nous vous avons identifié comme un utilisateur non-humain et, en tant que tel, vos actions sur ce site web sont limitées. S\'il s\'agit d\'une erreur, veuillez contacter Elia (operations.crm@elia.be) pour la faire corriger.',
      sections: {
        register: 'Nouveau sur le CRM ?',
        accountManagement: 'Gestion du compte utilisateur',
        accountManagementTooltip: 'Les utilisateurs ayant le rôle d\’administrateur peuvent ajouter, modifier ou supprimer des comptes utilisateurs via le module de préqualification.',
        crmModules: 'CRM modules'
      },
      controls: {
        loginintroduction: 'J\'ai déjà un compte ?',
        logindescription: 'Je m\'identifie',
        loginSM: 'Marché Secondaire',
        loginPDM: 'Contrôle de Pré-fourniture',
        loginAvMon: 'Obligation de Disponibilité et de Remboursement',
        loginSettlement: 'Rémunération & Settlement',
        login: 'Sign in',
        registerintroduction: 'Je n\'ai pas encore de compte ?',
        registerdescription: 'Inscrivez-vous comme Candidat CRM (entreprise)',
        register: 'S\'enregister',
        closeerror: 'Fermer',
        forgotintroduction: 'Mot de passe oublié',
        reactivateaccount: 'Réactiver le compte',
        forgotdescription: 'Cliquer ici',
        privacypolicy: 'Privacy policy'
      }
    },
    register: {
      controls: {
        nextstep: 'Continuer',
        backstep: 'Retour',
        submit: 'Soumettre'
      },
      company: {
        step: 'Étape 1',
        title: 'Information de l\'entreprise',
        description: 'Si vous souhaitez soumettre un formulaire de demande comme personne physique, veuillez contacter {mailto}.',
        sections:{
          info: 'Identification de l\'entreprise',
          address: 'Adresse de l\'entreprise'
        },
        labels: {
          name: 'Nom de l\'entreprise *',
          street: 'Rue *',
          housenumber: 'Numéro *',
          zip: 'Code postal *',
          city: 'Ville *',
          country: 'Pays *',
          phone: 'Téléphone',
          fax: 'Fax',
          registrationnumber: 'Numéro d\'identification (TVA) *',
          businessnumber: 'Numéro d\'entreprise *',
          foundationdate: 'Date de fondation',
          legalstatus: 'Statut légal *'
        },
        tooltips: {
          registrationnumber: 'Le numéro d\'identification TVA, parfois aussi appelé numéro d\'immatriculation à la TVA, est le numéro unique permettant d\'identifier un assujetti (entreprise) ou une entité juridique non assujettie immatriculés à la TVA.\n • En Belgique, le numéro d\'identification commence par "BE" suivi de 10 chiffres (exemple : BE0999999999).\n • En Allemagne, le numéro d\'enregistrement ("Umsatzsteuer-Identifikationsnummer") commence par "DE" suivi de 9 chiffres (exemple : DE999999999).',
          businessnumber: 'Les entreprises utilisent leur numéro d\'entreprise unique comme moyen d\'identification.\n • En Belgique, le numéro d\'entreprise est composé de 10 chiffres, qui sont les mêmes que ceux utilisés dans le numéro d\'identification.\n • En Allemagne, le numéro d\'entreprise ("Betriebssteuernummer") est composé de 10 à 13 chiffres.',
        },
        errors: {
          required: {
            name: 'Veuillez entrer un nom d\'entreprise',
            street: 'Veuillez entrer une rue',
            number: 'Veuillez entrer un numéro',
            zip: 'Veuillez entrer un code postal',
            city: 'Veuillez entrer une ville',
            country: 'Veuillez choisir un pays',
            registrationNumber: 'Veuillez entrer un numéro de TVA',
            businessnumber: 'Veuillez entrer un numéro d\'entreprise',
            legalstatus: 'Please enter a legal status'
          },
          length: {
            name: 'Le nom de l\'entreprise ne peut pas excéder {maximum} caractères',
            street: 'Le nom de la rue ne peut pas excéder {maximum} caractères',
            number: 'Le numéro ne peut pas excéder {maximum} caractères',
            zip: 'Le code postal ne peut pas excéder {maximum} caractères',
            city: 'Le nom de la ville ne peut pas excéder {maximum} caractères',
            phone: 'Le numéro de téléphone ne peut pas excéder {maximum} caractères',
            fax: 'Le numéro de fax ne peut pas excéder {maximum} caractères',
            registrationNumber: 'Le numéro d\'identification (TVA) ne peut pas excéder {maximum} caractères',
            businessnumber: 'Le numéro d\'entreprise ne peut pas excéder {maximum} caractères',
          },
          type:{
            alphanumerics: 'Seuls les caractères alphanumériques sont autorisés (pas de points, d\'espaces ou d\'autres symboles)',
            countrycode: 'Les deux premiers caractères doivent correspondre au code de pays ISO 3166 («BE» pour la Belgique)'
          }
        }
      },
      contacts: {
        step: 'Étape 2',
        title: 'Coordonnées de contact',
        contactinteration: 'Contact {number}',
        controls: {
          add: 'Ajouter une autre personne de contact',
          delete: 'Supprimer',
          deletetitle: 'Supprimer {contactName}?',
          deletedescription: 'Vous êtes sur le point de supprimer ce contact. Êtes-vous sûr de vouloir continuer ?',
          deleteconfirm: 'confirmer',
          deletecancel: 'annuler'
        },
        sections:{
          competences: 'Je souhaiterais être le point de contact:',
          roles: 'Rôles'
        },
        labels: {
          language: 'Langue *',
          civilstatus: 'Status civil *',
          firstname: 'Prénom *',
          lastname: 'Nom de famille *',
          function: 'Fonction *',
          phone: 'Téléphone',
          mobile: 'Mobile *',
          email: 'E-mail *',
          gdprtitle: 'Politique de confidentialité',
          gdpragree: 'Veuillez télécharger le document afin de consulter la politique de confidentialité de l’interface CRM.',
          gdprlink: 'Politique de confidentialité'
        },
        errors: {
          required: {
            civilstatus: 'Veuillez choisir un état civil',
            language: 'Veuillez choisir une a langue',
            firstName: 'Veuillez entrer un prénom',
            lastName: 'Veuillez entrer un nom de famille',
            function: 'Veuillez entrer une fonction',
            mobile: 'Veuillez entrer un numéro de mobile',
            email: 'Veuillez entrer une adresse e-mail',
            contactFor: 'Veuillez noter que pour que votre formulaire de demande soit approuvé, vous devez sélectionner les sujets indiqués par une étoile (*) pour au moins une des personnes de contact fournies',
            allcompetences: 'Vous devez sélectionner les sujets marqués d\'une étoile (*) pour au moins une des personnes de contact fournies',
            singleinvestment: 'Seul une personne de contact peut être fournie pour les sujets ayant trait au « Dossier d\'investissement »',
            gdpr: 'Veuillez cocher la case afin de soumettre votre formulaire de demande'
          },
          length: {
            firstName: 'Le prénom ne peut pas excéder {maximum} caractères',
            lastName: 'Le nom de famille ne peut pas excéder {maximum} caractères',
            function: 'La fonction ne peut pas excéder {maximum} caractères',
            phone: 'Le numéro de téléphone ne peut pas excéder {maximum} caractères',
            mobile: 'Le numéro de mobile ne peut pas excéder {maximum} caractères',
            email: 'L\'adresse e-mail ne peut pas excéder {maximum} caractères',
          },
          type: {
            email: 'Veuillez entrer une adresse e-mail valide',
          }
        }
      }
    },
    thanks: {
      title: 'Merci!',
      message: 'Votre formulaire de demande a bien été reçu.',
      message2:'Une fois approuvé par Elia, vous recevrez vos accès pour l\'Interface IT CRM via les adresses e-mail fournies dans les coordonnées de contact.',
      back:'Retour sur le site'
    }
  },
  nl: {
    general: {
      welcome: 'Welkom bij de CRM IT Interface voor het Belgisch Capaciteitsvergoedingsmechanisme',
      description: 'In geval van vragen of problemen met de tool, gelieve een e-mail te sturen naar {mailto}.',
      error: 'Er deed zich een probleem voor op de website. Probeer het later nog eens. We verontschuldigen ons voor het eventuele ongemak dat dit kan veroorzaken.',
      captchaerror: 'We hebben u geïdentificeerd als een niet-menselijke gebruiker en als zodanig zijn uw acties op deze website beperkt. Als dit een fout is, neem dan contact op met Elia (operations.crm@elia.be) om het te laten herstellen.',
      sections: {
        register: 'Eerste keer bij CRM?',
        accountManagement: 'Gebruikers accountbeheer',
        accountManagementTooltip: 'Gebruikers met de Admin rol kunnen gebruikersaccounts toevoegen, bewerken of verwijderen via de Prekwalificatiemodule.',
        crmModules: 'CRM modules'
      },
      controls: {
        loginintroduction: 'Heb je al een account?',
        logindescription: 'Log in',
        loginSM: 'Secundaire Markt',
        loginPDM: 'Pre-leveringscontrole',
        loginAvMon: 'Beschikbaarheids en Terugbetalingsverplichting',
        loginSettlement: 'Remuneratie & Settlement',
        login: 'Sign in',
        registerintroduction: 'Nog geen account?',
        registerdescription: 'Registreer als CRM-Kandidaat (onderneming)',
        register: 'Registeren',
        closeerror: 'Close',
        forgotintroduction: 'Wachtwoord vergeten',
        reactivateaccount: 'Account opnieuw activeren',
        forgotdescription: 'Klik hier',
        privacypolicy: 'Privacy policy'
      }
    },
    register: {
      controls: {
        nextstep: 'Volgende',
        backstep: 'Terug',
        submit: 'Inzenden'
      },
      company: {
        step: 'Stap 1',
        title: 'Bedrijfsinformatie',
        description: 'Indien u een aanvraagformulier als natuurlijk persoon wilt indienen, neem dan contact op met {mailto}.',
        sections:{
          info: 'Bedrijfsidentificatie',
          address: 'Bedrijfsadres'
        },
        labels: {
          name: 'Bedrijfsnaam *',
          street: 'Straat *',
          housenumber: 'Nummer *',
          zip: 'Postcode *',
          city: 'Plaats *',
          country: 'Land *',
          phone: 'Telefoon',
          fax: 'Fax',
          registrationnumber: 'Registratienummer (BTW) *',
          businessnumber: 'Ondernemingsnummer *',
          foundationdate: 'Oprichtingsdatum',
          legalstatus: ' Burgerlijke staat *'
        },
        tooltips: {
          registrationnumber: 'Het BTW-registratienummer, ook wel BTW-identificatienummer genoemd, is het unieke nummer dat een belastingplichtige (bedrijf) of niet-belastingplichtige rechtspersoon identificeert die voor de BTW is geregistreerd.\n • In België begint het registratienummer met "BE", gevolgd door 10 cijfers (voorbeeld: BE0999999999).\n • In Duitsland begint het registratienummer ("Umsatzsteuer-Identifikationsnummer") met "DE" gevolgd door 9 cijfers (voorbeeld: DE9999999).',
          businessnumber: 'Bedrijven gebruiken hun unieke bedrijfsnummer als identificatiemiddel.\n • In België bestaat het ondernemingsnummer uit 10 cijfers, die dezelfde 10 cijfers zijn die in het Registratienummer worden gebruikt.\n • In Duitsland bestaat het ondernemingsnummer ("Betriebssteuernummer") uit 10 tot 13 cijfers.',
        },
        errors: {
          required: {
            name: 'Voer een bedrijfsnaam in',
            street: 'Voer een straat in',
            number: 'Voer een huisnummer in',
            zip: 'Voer een postcode in',
            city: 'Voer een plaats in',
            country: 'Kies een land',
            registrationNumber: 'Voer een registratienummer in',
            businessnumber: 'Voer een ondernemingsnummer in',
            legalstatus: 'Voer een burgerlijke staat in'
          },
          length: {
            name: 'Bedrijfsnaam mag niet langer zijn dan {maximum} tekens',
            street: 'Straat mag niet langer zijn dan {maximum} tekens',
            number: 'Huisnummer mag niet langer zijn dan {maximum} tekens',
            zip: 'Postcode mag niet langer zijn dan {maximum} tekens',
            city: 'Plaats mag niet langer zijn dan {maximum} tekens',
            phone: 'Telefoon mag niet langer zijn dan {maximum} tekens',
            fax: 'Fax mag niet langer zijn dan {maximum} tekens',
            registrationNumber: 'Registratienummer mag niet langer zijn dan {maximum} tekens',
            businessnumber: 'Ondernemingsnummer mag niet langer zijn dan {maximum} tekens',
          },
          type:{
            alphanumerics: 'Alleen alfanumerieke tekens zijn toegestaan (geen punten, spaties of andere symbolen)',
            countrycode: 'De eerste twee tekens moeten overeenkomen met de ISO 3166-landcode (‘BE’ voor België)'
          }
        }
      },
      contacts: {
        step: 'Stap 2',
        title: 'Contactgegevens',
        contactinteration: 'Contact {number}',
        controls: {
          add: 'Een andere contactpersoon toevoegen',
          delete: 'verwijderen',
          deletetitle: '{contactName} verwijden?',
          deletedescription: 'U staat op het punt om dit contact te verwijderen, weet u zeker dat u verder wilt gaan?',
          deleteconfirm: 'Bevestigen',
          deletecancel: 'cancel'
        },
        sections:{
          competences: 'Ik ben de contactpersoon:',
          roles: 'Roles'
        },
        labels: {
          language: 'Taal *',
          civilstatus: 'Burgerlijke staat *',
          firstname: 'Voornaam *',
          lastname: 'Achternaam *',
          function: 'Functie *',
          phone: 'Telefoon',
          mobile: 'GSM *',
          email: 'E-mailadres *',
          gdprtitle: 'Privacy-beleid',
          gdpragree: 'Gelieve het document te downloaden om het privacy-beleid van de CRM interface te bekijken.',
          gdprlink: 'Privacy-beleid'
        },
        errors: {
          required: {
            civilstatus: 'Kies een civil status',
            language: 'Kies een taal',
            firstName: 'Voer een voornaam in',
            lastName: 'Voer een achternaam in',
            function: 'Voer een functie in',
            mobile: 'Voer een telefoonnummer in',
            email: 'Voer een e-mailadres in',
            contactFor: 'Om uw aanvraagformulier te kunnen goedkeuren, dient u voor ten minste één van de opgegeven contactpersonen de met een sterretje (*) aangeduide zaken te selecteren.',
            allcompetences: 'Alle U dient voor ten minste één van de opgegeven contactpersonen de zaken te selecteren die zijn aangegeven met een sterretje (*).',
            singleinvestment: 'Bij slechts 1 contact kan het selectievakje \'investeringsdossier\' worden aangevinkt',
            gdpr: 'Gelieve het vakje aan te vinken om uw gegevensformulier in te dienen'
          },
          length: {
            firstName: 'Voornaam mag niet langer zijn dan {maximum} tekens',
            lastName: 'Achternaam mag niet langer zijn dan {maximum} tekens',
            function: 'Functie mag niet langer zijn dan {maximum} tekens',
            phone: 'Telefoonnummer mag niet langer zijn dan {maximum} tekens',
            mobile: 'GSM nummer mag niet langer zijn dan {maximum} tekens',
            email: 'E-mailadres mag niet langer zijn dan {maximum} tekens',
          },
          type: {
            email: 'Voer een geldig e-mail adres in',
          }
        }
      }
    },
    thanks: {
      title: 'Dank u wel!',
      message: 'Uw aanvraagformulier is ontvangen.',
      message2:'Zodra het door ELIA is goedgekeurd, ontvangt u uw toegang tot de CRM IT Interface via de e-mailadressen die bij elke contactpersoon zijn opgegeven.',
      back:'Ga terug naar de site'
    }
  },
};

Vue.use(VueI18n);

export const i18n: VueI18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
});

export default i18n;
